import { render } from "./CancelUserPermissionsModal.vue?vue&type=template&id=df503166&scoped=true"
import script from "./CancelUserPermissionsModal.vue?vue&type=script&lang=js"
export * from "./CancelUserPermissionsModal.vue?vue&type=script&lang=js"

import "./CancelUserPermissionsModal.vue?vue&type=style&index=0&id=df503166&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df503166"]])

export default __exports__